import { WidgetViewExtension } from '@blocksuite/std';
import { literal, unsafeStatic } from 'lit/static-html.js';

import { AFFINE_DOC_REMOTE_SELECTION_WIDGET } from './doc';

export { ENDED_RUN_POINTER_MS } from './agent-pointer-display';
export * from './doc';
export * from './edgeless';

export const docRemoteSelectionWidget = WidgetViewExtension(
  'affine:page',
  AFFINE_DOC_REMOTE_SELECTION_WIDGET,
  literal`${unsafeStatic(AFFINE_DOC_REMOTE_SELECTION_WIDGET)}`
);

export { edgelessRemoteSelectionWidget } from './viewing';
